import React from 'react';
import { useNavigate, UseNavigateProps } from '@global-ecom/nitro-uds/hooks';

import { useActionCta, UseActionCtaProps } from './useActionCta';

export type LinkCtaProps = UseNavigateProps &
  UseActionCtaProps & {
    /**
     * Render data-test-id attribute, used for cypress tests
     */
    dataTestId?: string;
  };

/**
 * LinkCta is a link that is styled as a rectangle call-to-action, identical to the `ButtonCta` element
 *
 * @example
 * ```
 * <LinkCta label="Shop Running" href="/running" />
 * ```
 */
export const LinkCta = React.forwardRef<HTMLAnchorElement, LinkCtaProps>(
  function LinkCta(props, forwardedRef) {
    const {
      label,
      srOnlyLabel,
      className,
      variant,
      invert,
      size,
      color,
      mode,
      round,
      bleed,
      dimmed,
      icon,
      iconEnd,
      loading,
      uppercase,
      bold,
      underlineSizeInPx,
      dataTestId,
      ...rest
    } = props;

    const actionCtaProps = useActionCta({
      label,
      srOnlyLabel,
      className,
      variant,
      invert,
      size,
      color,
      mode,
      round,
      bleed,
      dimmed,
      icon,
      iconEnd,
      loading,
      uppercase,
      bold,
      underlineSizeInPx,
    });

    const navigateProps = useNavigate(rest);

    return (
      <a
        ref={forwardedRef}
        {...actionCtaProps}
        {...navigateProps}
        data-test-id={dataTestId}
      />
    );
  }
);

// Temporarily export both LinkCta and Link whilst we migrate to LinkCta
export const Link = LinkCta;
